import { Color } from "../../../core/models/entities/LogoOptions";
import { useTranslation } from "react-i18next";
import ColorBlockWithToolTip from "../../screens/logo-editor/componenets/ColorBlockWithToolTip";
import { systemColorDisplayName } from "../../../utils/systemColors";

interface Props {
  color: Color;
  showName?: boolean;
  maxWidth?: string;
}

export function VectorColorElement({ color, showName, maxWidth = "max-w-16" }: Props) {
  const { t } = useTranslation();
  return (
    <div className={"flex align-middle space-x-1"}>
      <ColorBlockWithToolTip onClick={() => {}} size={"sm"} color={color} />
      {showName && (
        <span className={`truncate ${maxWidth}`}>
          {/* Same strings as the old compLogoDesign.color* keys in all 10
              locales — centralized via the shared system-color utility. */}
          {systemColorDisplayName(color, t) ?? color.name}
        </span>
      )}
    </div>
  );
}
